import { Injectable } from '@angular/core';

import * as momentNs from 'moment';
const moment = momentNs;

import { DatepickerValidatorService } from '../datepicker-validator.service';

export interface CfCalendarDate {
  date: Date | string;
  month: number;
  day: number;
  year: number;
}

/**
 * Service to perform all calendar related
 * calculations. Moment should only be imported
 * here so that it can be removed as a dependency
 * in the future if desired.
 */
@Injectable()
export class CalendarService {

  constructor(
    private datepickerValidatorSvc: DatepickerValidatorService
  ) { }

  /**
   * Returns a 2D array represnting the days of the month.
   * Each row of the array is a weekday.
   */
  getDaysOfMonth(month, year) {
    const monthNum = this.getMonthNumber(month); // month name as a number
    const monthYear = year + '-' + monthNum; // proper format for moment
    const numberOfDays = moment(monthYear, 'YYYY-MM').daysInMonth();
    const startOfMonth = moment(monthYear, 'YYYY-MM').startOf('month');

    const days = [[], []];
    let weekNumber = 0;

    // 2D array should have empty elements instead
    // of previous months days.
    this.insertEmptyDays(days, startOfMonth.day());

    for (let i = 1; i <= numberOfDays; i++) {
      if (days[weekNumber].length === 7) {
        weekNumber++;
        days[weekNumber] = [];
      }

      days[weekNumber].push(i);
    }

    return days;
  }

  getMonths(maxDate) {
    const months = [];
    for (let i = 0; i < maxDate; i++) {
      months.push(moment.months()[i]);
    }
    return months;
  }

  getYears(maxDate, minDate) {
    const years = [];
    for (let i = minDate.getFullYear(); i <= maxDate.getFullYear(); i++) {
      years.push(i);
    }
    return years;
  }

  getWeekdays() {
    return moment.weekdays();
  }

  getCurrentMonth() {
    return moment().month();
  }

  getCurrentDay() {
    return moment().format('DD');
  }

  getCurrentYear() {
    return moment().year();
  }

  getMonthNumber(month) {
    return moment().month(month).format('MM');
  }

  getDayNumber(day) {
    if (day.toString().length === 1) {
      return '0' + day;
    } else {
      return day;
    }
  }

  /**
   * Converts a string to a date
   * @param string a date in string format
   */
  getDate(string): CfCalendarDate {
    const date = moment(string, 'MM/DD/YYYY').toDate();

    // return invalid date if year is out of range
    if (!this.datepickerValidatorSvc.isValid(string)) {
      return {
        date: 'Invalid Date',
        month: null,
        day: null,
        year: null
      };
    }

    return {
      date,
      month: date.getMonth(),
      day: date.getDate(),
      year: date.getFullYear()
    };
  }

  /**
   * This function inserts zeros for the weekdays that are
   * from the previous month.
   * @param days 2D array for days of the month
   * @param startDay the weekday number the month starts on
   */
  private insertEmptyDays(days, startDay) {
    for (let i = 1; i <= startDay; i++) {
      days[0].push(0);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/datepicker/calendar/calendar.service.ts